import React from 'react';
import { DividerWrapper, DividerLine, DividerLabel } from './Divider.styles';

const Divider = ({ label, className }) => (
  <DividerWrapper className={className}>
    <DividerLine />
    {label && <DividerLabel>{label}</DividerLabel>}
    <DividerLine />
  </DividerWrapper>
);

export default Divider;
